var map = {
	"./200/200 Big Ben 2.jpg": "cb06",
	"./200/200 Big Ben.jpg": "6fa1",
	"./200/200 Eiffel Tower.jpg": "32cd",
	"./200/200 Kalon.jpg": "70a1",
	"./200/200 Statue of Liberty.jpg": "52e5",
	"./200/200 Taj Mahal.jpg": "9670",
	"./200/200 The Shard.jpg": "6f76",
	"./Big Ben 2.jpg": "6651",
	"./Big Ben.jpg": "0c17",
	"./Eiffel Tower.jpg": "46b5",
	"./Kalon.jpg": "f37d",
	"./Statue of Liberty.jpg": "476d",
	"./Taj Mahal.jpg": "13cb",
	"./The Shard.jpg": "b115"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4539";